module.exports = __webpack_public_path__ + "img/56.e5290b6.jpg";